module.exports = __webpack_public_path__ + "img/mascot-chair-mask.de4535f6.png";